import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash-es';

export interface FormState {
  [key: string]: any;
  originalValues?: Record<string, any>;
}

const initialState: FormState = {};

const CurrentForm = createSlice({
  name: 'CurrentForm',
  initialState,
  reducers: {
    addField: (state, action: PayloadAction<FormState>) => {
      return { ...state, ...action.payload };
    },
    updateField: (state, action: PayloadAction<FormState>) => {
      return { ...state, ...action.payload };
    },
    replaceForm: (_state, action: PayloadAction<FormState>) => {
      return { ...action.payload };
    },
    removeField: (state, action: PayloadAction<string>) => {
      const newState = cloneDeep(state);
      delete newState[action.payload];
      return newState;
    },
    setOriginalValues: (state, action: PayloadAction<Record<string, any>>) => {
      state.originalValues = { ...state.originalValues, ...action.payload };
    },
    submitForm: (state) => {
      return state;
    },
    resetForm: () => {
      return initialState;
    },
  },
});

export const { addField, updateField, replaceForm, resetForm, removeField, setOriginalValues } = CurrentForm.actions;
export default CurrentForm.reducer;
